module.exports = __webpack_public_path__ + "img/bg-noise-salmon.6139733.jpg";